var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout",class:{ 'light-theme': !_vm.isDarkTheme, 'dark-theme': _vm.isDarkTheme }},[_c('MainHeader'),_c('main',{staticClass:"main-content"},[_vm._t("default")],2),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }